import { Component } from '@angular/core';

@Component({
  selector: 'csa-savebar',
  templateUrl: './savebar.component.html',
  styleUrls: ['./savebar.component.scss'],
  standalone: false,
})
export class SavebarComponent {}
